import Vue from 'vue';

Vue.filter('emailStatus', (value) => {
  switch (value) {
    case undefined:
    case null:
    case '':
    case 0:
      return 'Ausstehend';
    case 10:
      return 'Im Versand';
    case 'Delivery':
    case 1:
    case 20:
      return 'Zugestellt';
    case 'Open':
    case 2:
    case 90:
      return 'Geöffnet';
    case 99:
    case 'Click':
    case 3:
      return 'Geklickt';
    case 30:
      return 'Soft Bounce';
    case 40:
      return 'Hard Bounce';
    default:
      return value;
  }
});
